
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as paymentCSnglmjCGWLDA5JGj6tDrSMnwOYcFPRcNAGeyJnOidIMeta } from "/opt/buildhome/repo/pages/payment.vue?macro=true";
import { default as milestonesOOUCBYeW_R1WJbuSUxS7qak2TOiBTCA_zXHzdYfDNjYMeta } from "/opt/buildhome/repo/pages/milestones.vue?macro=true";
import { default as verify_45otpYiKjbo5PNXBjIQfoJA48os7V1IlkbyWyA8HP137FfycMeta } from "/opt/buildhome/repo/pages/verify-otp.vue?macro=true";
import { default as case_45historyXDI_nNLB94qiVDZM5o1kOZ0be8Oo45zd_JEd8QqaYWAMeta } from "/opt/buildhome/repo/pages/case-history.vue?macro=true";
import { default as payment_45otherGEF8My_45YME6KG3GFxMQxFmlX21MrhQKysLepDEA6lwgMeta } from "/opt/buildhome/repo/pages/payment-other.vue?macro=true";
import { default as _91id_93pgxoV4Y_570FN5x_8itXNtJN3t1Z0aZCZbmoKHXKQ1QMeta } from "/opt/buildhome/repo/pages/documents/[id].vue?macro=true";
import { default as payment_45detailskc2MAhv4g6_JdKI5HAH58_jCvUcn8yX9F0HMJrF4hc0Meta } from "/opt/buildhome/repo/pages/payment-details.vue?macro=true";
import { default as doneGCAbI4TAAzAOpMUbWgWl66B8dd05LQYEhbqxayV2dDMMeta } from "/opt/buildhome/repo/pages/additional-enquiries/done.vue?macro=true";
import { default as indexhXnStDJ11pHsP_45J4HnZDPyJbwxG1pPpwJUWdY07bggQMeta } from "/opt/buildhome/repo/pages/additional-enquiries/index.vue?macro=true";
import { default as guidancelKtPi5_45lssrrL2HiWLNdVOM37bUYzt7MV2OXtCpgFI0Meta } from "/opt/buildhome/repo/pages/additional-enquiries/guidance.vue?macro=true";
import { default as signed_45offNPlADe4xRmeYste4r9cmjSp1Ewp4lY07YtBkzMtpb6MMeta } from "/opt/buildhome/repo/pages/additional-enquiries/signed-off.vue?macro=true";
import { default as indexukWVGelofe2v4oED1ClsvjKJvknpoi2Bj5YkCRjxuZYMeta } from "/opt/buildhome/repo/pages/documents/[matter_type]/[group]/index.vue?macro=true";
import { default as blocking_45exchangeQIiA9JC_pUxFYAYo3Xer2arl374qmpHCwnS6i_WR_45dkMeta } from "/opt/buildhome/repo/pages/additional-enquiries/blocking-exchange.vue?macro=true";
import { default as component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta } from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo } from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {}), ...{"middleware":["guest","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "payment",
    path: "/payment",
    meta: { ...(paymentCSnglmjCGWLDA5JGj6tDrSMnwOYcFPRcNAGeyJnOidIMeta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/payment.vue")
  },
  {
    name: "milestones",
    path: "/milestones",
    meta: { ...(milestonesOOUCBYeW_R1WJbuSUxS7qak2TOiBTCA_zXHzdYfDNjYMeta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/milestones.vue")
  },
  {
    name: "verify-otp",
    path: "/verify-otp",
    meta: { ...(verify_45otpYiKjbo5PNXBjIQfoJA48os7V1IlkbyWyA8HP137FfycMeta || {}), ...{"middleware":["maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/verify-otp.vue")
  },
  {
    name: "case-history",
    path: "/case-history",
    meta: { ...(case_45historyXDI_nNLB94qiVDZM5o1kOZ0be8Oo45zd_JEd8QqaYWAMeta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/case-history.vue")
  },
  {
    name: "payment-other",
    path: "/payment-other",
    meta: { ...(payment_45otherGEF8My_45YME6KG3GFxMQxFmlX21MrhQKysLepDEA6lwgMeta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/payment-other.vue")
  },
  {
    name: "documents-id",
    path: "/documents/:id()",
    meta: { ...(_91id_93pgxoV4Y_570FN5x_8itXNtJN3t1Z0aZCZbmoKHXKQ1QMeta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/documents/[id].vue")
  },
  {
    name: "payment-details",
    path: "/payment-details",
    meta: { ...(payment_45detailskc2MAhv4g6_JdKI5HAH58_jCvUcn8yX9F0HMJrF4hc0Meta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/payment-details.vue")
  },
  {
    name: "additional-enquiries-done",
    path: "/additional-enquiries/done",
    meta: { ...(doneGCAbI4TAAzAOpMUbWgWl66B8dd05LQYEhbqxayV2dDMMeta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/additional-enquiries/done.vue")
  },
  {
    name: "additional-enquiries",
    path: "/additional-enquiries",
    meta: { ...(indexhXnStDJ11pHsP_45J4HnZDPyJbwxG1pPpwJUWdY07bggQMeta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/additional-enquiries/index.vue")
  },
  {
    name: "additional-enquiries-guidance",
    path: "/additional-enquiries/guidance",
    meta: { ...(guidancelKtPi5_45lssrrL2HiWLNdVOM37bUYzt7MV2OXtCpgFI0Meta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/additional-enquiries/guidance.vue")
  },
  {
    name: "additional-enquiries-signed-off",
    path: "/additional-enquiries/signed-off",
    meta: { ...(signed_45offNPlADe4xRmeYste4r9cmjSp1Ewp4lY07YtBkzMtpb6MMeta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/additional-enquiries/signed-off.vue")
  },
  {
    name: "documents-matter_type-group",
    path: "/documents/:matter_type()/:group()",
    meta: { ...(indexukWVGelofe2v4oED1ClsvjKJvknpoi2Bj5YkCRjxuZYMeta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/documents/[matter_type]/[group]/index.vue")
  },
  {
    name: "additional-enquiries-blocking-exchange",
    path: "/additional-enquiries/blocking-exchange",
    meta: { ...(blocking_45exchangeQIiA9JC_pUxFYAYo3Xer2arl374qmpHCwnS6i_WR_45dkMeta || {}), ...{"middleware":["authenticated","maintainance"]} },
    component: () => import("/opt/buildhome/repo/pages/additional-enquiries/blocking-exchange.vue")
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/main",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/main/overview",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/main/task-sign/*",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/main/case-history/*",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/main/purchase-docs/*",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  },
  {
    name: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJoMeta?.name,
    path: "/main/sale-docs/*",
    component: component_45stub_450o40pIUSw8QaPELG0OvfZH1GwyPyIaXd7Bv_45sPiDJo
  }
]